<template>
  <pt-insure-info-form class="pt-insure-info-form__page"></pt-insure-info-form>
</template>

<script>
import PtInsureInfoForm from 'cps/insurance-claims/pt-insure-info/pt-insure-info-form/withData.vue'
export default {
  name: 'pt-insure-info-form__view',
  components: {
    'pt-insure-info-form': PtInsureInfoForm
  }
}
</script>
